import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ to, style }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button 
      onClick={handleClick}
      className="btn btn-secondary"
      style={{ 
        marginBottom: '1rem', 
        display: 'inline-flex', 
        alignItems: 'center', 
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        fontSize: '0.9rem',
        ...style 
      }}
    >
      <span>←</span> 返回
    </button>
  );
};

export default BackButton;
